export default __webpack_public_path__ + "static/media/dashboard-active.47e665de.svg";